import { graphql, useStaticQuery } from "gatsby";
import { map, reduce, some } from "lodash";

const useShouldShowMultiview = (props = {}, isHeader = false) => {
    const { wp } = useStaticQuery(graphql`
        query CADModelStaticQuery {
            wp {
                optionsPage {
                    globalOptions {
                        showMultiviewCadModel
                        multiviewProductCategories {
                            id
                        }
                    }
                }
            }
        }
    `);

    const globalOptions = wp?.optionsPage?.globalOptions;
    const showMultiviewCadModel = !!globalOptions?.showMultiviewCadModel;

    if (isHeader || !showMultiviewCadModel) {
        return {
            shouldLoadScript: showMultiviewCadModel,
            shouldShowMultiview: false,
        };
    }

    const multiviewProductCategories = map(
        globalOptions?.multiviewProductCategories,
        "id",
    );

    const productCategories = reduce(
        props?.productCategories?.nodes,
        (acc, productCategory) => {
            const id = productCategory?.id;
            const ancestors = productCategory?.ancestors?.nodes;

            if (ancestors) {
                acc.children.push(id);
            } else {
                acc.parent.push(id);
            }

            return acc;
        },
        { parent: [], children: [] },
    );

    const shouldShowMultiview = some(
        multiviewProductCategories,
        (multiviewCategoryId) => {
            const { parent, children } = productCategories;
            return (
                parent.includes(multiviewCategoryId) ||
                children.includes(multiviewCategoryId)
            );
        },
    );

    return { shouldLoadScript: true, shouldShowMultiview };
};

export default useShouldShowMultiview;
